/* Growth Pro Tips Slider section 
--------------------------------------*/



class ProTipsSlider {
  constructor(parent) {
    this.parent = parent;
    if (!this.parent) {
      return;
    }
    this.slider();
  }
  slider = () => {
    let proTipsSlider = qs('.pro-tips-slider-js');
    new Swiper(proTipsSlider, {
      loop: true,
      slidesPerView: 3,
      slidesPerGroup: 1,

      breakpoints: {
        1: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        }
      },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

new ProTipsSlider(qs('.pro-tips-slider-js'));
